<div class="jackpot-success-wrapper">
  <div class="success-ic-wrap ion-text-center">
    <div class="greeting-icon">🎉</div>
  </div>
  <p class="success-msg">
    {{'jackpot-success.Jackpot' | translate}}<br />
    {{'jackpot-success.created' | translate}}
  </p>
  <p class="jackpot-label">{{'jackpot-success.charged' | translate}}</p>
  <ion-button class="view-btn" (click)="close()">{{'jackpot-success.Ok' | translate}}</ion-button>
</div>